import { apiRequest } from './client';

const operations = new Set([
  'review',
  'fare-rules',
  'seat-map',
  'book',
  'fare-validation',
  'confirm-booking',
  'booking-details',
  'release-hold',
  'cancellation/charges',
  'cancellation',
  'cancellation/status',
  'supplier-account',
]);

export function flightOperation(operation, supplierCode, request, token, signal) {
  if (!operations.has(operation)) {
    throw new Error(`Unsupported flight operation: ${operation}`);
  }
  if (!supplierCode) {
    throw new Error('A supplier code is required for this flight operation.');
  }

  return apiRequest(`/api/flights/${operation}`, {
    body: { supplierCode, request },
    token,
    ...(signal ? { signal } : {}),
  });
}

export function reviewFlight(supplierCode, offerReferences, token) {
  return flightOperation('review', supplierCode, { offerReferences }, token);
}

export function getSeatMap(supplierCode, bookingId, signal) {
  return flightOperation('seat-map', supplierCode, { bookingId }, undefined, signal);
}

/** Live status, PNRs and booked seats, meals and baggage. Guests pass the booking email. */
export function getFlightBooking(supplierBookingId, email, token, signal) {
  return apiRequest('/api/flights/bookings/details', {
    body: { supplierBookingId, email: email || null },
    token,
    ...(signal ? { signal } : {}),
  });
}

/** Guest or signed-in checkout: books the reviewed fare and links it to an account by email. */
export function checkoutFlight(request, token) {
  return apiRequest('/api/flights/checkout', { body: request, token });
}

export function bookFlight(supplierCode, request, token) {
  return flightOperation('book', supplierCode, request, token);
}
